import { Button } from "GameObjects/UI/Button";
import * as Constants from "Data/Constants";
import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";
import * as VO from "Data/VoiceOver";
import * as SFX from "Data/SoundEffect";
import Settings from "Data/Settings";
import { Howler } from "howler";
import {FreePlayMenuLayout} from "Layouts/FreePlayMenuLayout";
import { AbstractGameState } from "./AbstractGameState";
import SettingsPopup from "Popups/SettingsPopup";
import { Intro } from "./Intro";
import { Background } from "GameObjects/UI/Background";
import { LayoutSprite } from "GameObjects/UI/LayoutSprite";
import { FlyingGame } from "States/FlyingGame";
import { DuckSwapGame } from "States/DuckSwapGame";
import { RestStopGame } from "States/RestStopGame";
import GameState from "Data/GameState";
import { LayoutButton } from "GameObjects/UI/LayoutButton";
import { Application } from "Application";

export class FreePlayMenu extends AbstractGameState<typeof FreePlayMenuLayout> implements ReturnType<typeof FreePlayMenuLayout> {

    public static readonly NAME = "FreePlayMenu";
    public readonly layout = FreePlayMenuLayout;

    public readonly bg: LayoutSprite;
    public readonly flyingButton: LayoutButton;
    public readonly restStopButton: LayoutButton;
    public readonly buttonfive: LayoutButton;
    public readonly buttonseven: LayoutButton;
    public readonly buttonnine: LayoutButton;

    protected readonly _bg = this.addChildAt(new Background(), 0);
    protected bgm = HLF.Application.instance.audio.getAudioTrack("flyingloop", HLF.AudioCategory.BGM) ?? HLF.Application.instance.audio.createAudioTrack("flyingloop", HLF.AudioCategory.BGM);

    protected nextState?: string;

    public constructor() {
        super();
        this.bg = this._bg.addChild(new LayoutSprite());
        this.flyingButton = this.addChild(new LayoutButton(this.onFlyingButtonClicked.bind(this), VO.TRAINING_MENU_FLIGHT_HOVER, SFX.UI_CLICK));
        this.restStopButton = this.addChild(new LayoutButton(this.onRestStopButtonClicked.bind(this), VO.TRAINING_REST_STOP_HOVER, SFX.UI_CLICK));

        this.buttonfive = this.addChild(new LayoutButton(this.onFiveDucksButtonClicked.bind(this), [VO.MAIN_MENU_PLAY_HOVER, VO.DUCKNUM_5], SFX.UI_CLICK));
        this.buttonseven = this.addChild(new LayoutButton(this.onSevenDucksButtonClicked.bind(this), [VO.MAIN_MENU_PLAY_HOVER, VO.DUCKNUM_7], SFX.UI_CLICK));
        this.buttonnine = this.addChild(new LayoutButton(this.onNineDucksButtonClicked.bind(this), [VO.MAIN_MENU_PLAY_HOVER, VO.DUCKNUM_9], SFX.UI_CLICK));
    }

    public init(pSize: PIXI.Point, pData: {name: string}) {
        super.init(pSize, pData);
        this.characterContainer.visible = false;
        this.buttonfive.visible = false;
        this.buttonseven.visible = false;
        this.buttonnine.visible = false;
    }

    public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);
        PubSub.publishSync(HLF.REGISTER_FOCUSABLES, [
            this.flyingButton,
            this.restStopButton,
            this.buttonfive,
            this.buttonseven,
            this.buttonnine,
        ]);

        if (Settings.audioDescriptionEnabled) {
            Application.instance.voiceover.playVO(VO.TRAINING_MENU_AUDIO_DESCRIPTION);
        }
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public gotoNextState(pName: string, pData?: object) {
        GameState.freePlay = true;
        super.gotoNextState(pName, {freePlay: true, ...pData});
    }

    protected onFlyingButtonClicked() {
        this.nextState = FlyingGame.NAME;
        this.flyingButton.visible = false;
        this.restStopButton.visible = false;
        this.buttonfive.visible = true;
        this.buttonseven.visible = true;
        this.buttonnine.visible = true;
        PubSub.publishSync(HLF.CLEAR_FOCUS);
    }

    protected onRestStopButtonClicked() {
        this.nextState = RestStopGame.NAME;
        this.flyingButton.visible = false;
        this.restStopButton.visible = false;
        this.buttonfive.visible = true;
        this.buttonseven.visible = true;
        this.buttonnine.visible = true;
        PubSub.publishSync(HLF.CLEAR_FOCUS);
    }


    protected onFiveDucksButtonClicked() {
        Settings.difficulty = 1/3;
        this.play(5);
    }

    protected onSevenDucksButtonClicked() {
        Settings.difficulty = 2/3;
        this.play(7);
    }

    protected onNineDucksButtonClicked() {
        Settings.difficulty = 3/3;
        this.play(9);
    }

    protected playHelpVO(): void {
        HLF.Application.instance.voiceover.playVO(VO.TRAINING_MENU_HELP);
    }

    protected play(pHowManyDucks: number) {
        GameState.flyingTimeElapsed = 0;
        // reset badges
        GameState.dodgedAllObstacles = true;
        GameState.perfectPonds = true;
        GameState.swaptastic = true;

        this.gotoNextState(this.nextState!, {ducks: GameState.GetDucks(pHowManyDucks)});
    }
}
